export const PENDING = "pending";
export const IN_PROGRESS = "inProgress";
export const SHIPPED = "shipped";
export const DELIVERED = "delivered";
export const INVOICED = "invoice";
